export default __webpack_public_path__ + "static/media/Hotpoint.539fa041.svg";